__webpack_require__.p = "/random-quote/";